module.exports = __webpack_public_path__ + "media/images/emblems/La_Sarraz-coat_of_arms-34e8beff01bb8c2ac620afee976fe33c.svg";